import {
  Button as MuiButton,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  FormGroup,
  Checkbox,
  Select as MuiSelect,
  TextField as MuiTextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { spacing } from "@mui/system";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import styled from "styled-components";
import { setSnackbar } from "../../snackbar/api/snackbar";
import { postByUnitUuid, put } from "../api/actions";
import FormControlLabel from "@mui/material/FormControlLabel";

const TextField = styled(MuiTextField)(spacing);
const Select = styled(MuiSelect)(spacing);

const MeterForm = (props) => {
  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    loadingIcon: {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
    },
  }));

  const onFieldChange = (event) => {
    props.meters.data.meter[event.target.name] = event.target.value;
  };

  const dispatch = useDispatch();


  // Handles vendor drop down
  const [physical, setPhysical] = React.useState(false);
  const [evMeter, setEVMeter] = React.useState(false);

  useEffect(() => {
    setPhysical(Boolean(props.meters.data.meter?.physical));
    setEVMeter(Boolean(props.meters.data.meter?.EVMeter));
  }, [props.meters.data.meter?.physical, props.meters.data.meter?.EVMeter]);

  const togglePhysical = () => {
    setPhysical(!physical);
    props.meters.data.meter.physical = !physical;
  };
  const toggleEVMeter = () => {
    setEVMeter(!evMeter);
    props.meters.data.meter.EVMeter = !evMeter;
  };

  // Handles vendor drop down
  const [state, setState] = React.useState("");
  const classes = useStyles();

  const save = () => {
    const m = props.meters.data.meter;
    const newMeter = {
      id: m.id,
      uuid: m.uuid,
      meterNum: m.meterNum,
      ERTNum: m.ERTNum,
      description: m.description,
      readSequence: m.readSequence,
      meterCode: m.meterCode,
      multiplier: parseInt(m.multiplier),
      physical: m.physical,
      EVMeter: m.EVMeter
    };
    props.onUpdate();
    if (!newMeter.id) {
      // TODO: get unit uuid from somewhere
      props.postByUnitUuid(props.units.data.unit.uuid, newMeter);
    } else {
      props.put(newMeter);
    }
    dispatch(setSnackbar(true, "success", "Meter updated."));
  };

  if (props.meters.meterIsLoading) {
    return (
      <Card mb={6}>
        <CardContent>
          <Typography variant="h3" gutterBottom>
            Loading...
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent>
        {/* Meter Details */}
        {/* <Grid container spacing={2} flexDirection={"column"}> */}
        <Grid container spacing={2} sx={{ my: 2 }}>
          <Grid item sm={6} xs={12} flex={1}>
            <TextField
              label="Meter Number"
              type="text"
              onChange={onFieldChange}
              name="meterNum"
              defaultValue={props.meters.data.meter.meterNum}
              //required
              fullWidth
              variant="outlined"
              slotProps={{ inputLabel: { shrink: true } }}
            />
          </Grid>
          <Grid item sm={6} xs={12} flex={1}>
            <TextField
              label="ERT Number"
              type="text"
              onChange={onFieldChange}
              name="ERTNum"
              defaultValue={props.meters.data.meter.ERTNum}
              //required
              fullWidth
              variant="outlined"
              slotProps={{ inputLabel: { shrink: true } }}
            />
          </Grid>
        </Grid>

        <Grid container item spacing={2} sx={{ my: 2 }}>
          <Grid item md={8} xs={12} flex={1}>
            <TextField
              label="Description"
              type="text"
              onChange={onFieldChange}
              defaultValue={props.meters.data.meter.description}
              name="description"
              fullWidth
              variant="outlined"
              slotProps={{ inputLabel: { shrink: true } }}
            />
          </Grid>
          <Grid item md={4} xs={12} flex={1}>
            <TextField
              label="Read Sequence"
              type="text"
              onChange={onFieldChange}
              defaultValue={props.meters.data.meter.readSequence}
              name="readSequence"
              fullWidth
              variant="outlined"
              slotProps={{ inputLabel: { shrink: true } }}
            />
          </Grid>
        </Grid>

        <Grid container item spacing={2} sx={{ my: 2 }}>
          <Grid item md={6} xs={12} flex={1}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel id="selectedAccountStatusDropDownLabel">
                Meter Code
              </InputLabel>
              <Select
                labelId="selectedAccountStatusDropDownLabel"
                id="selectedAccountStatusDropDown"
                defaultValue={props.meters.data.meter.meterCode}
                onChange={onFieldChange}
                name="meterCode"
                label="Meter Code"
              >{[
                <MenuItem id="AccountStatusOption1" value={"1"}>
                  Primary
                </MenuItem>,
                <MenuItem id="AccountStatusOption3" value={"0"}>
                  Secondary
                </MenuItem>
              ]}
              </Select>
            </FormControl>
          </Grid>
          <Grid item sm={6} xs={12} flex={1}>
            <TextField
              label="Multiplier"
              type="number"
              onChange={onFieldChange}
              name="multiplier"
              defaultValue={props.meters.data.meter.multiplier}
              //required
              fullWidth
              variant="outlined"
              slotProps={{ inputLabel: { shrink: true } }}
            />
          </Grid>
        </Grid>
        <FormGroup row>
          <FormControlLabel
            control={
              <Checkbox
                checked={physical}
                onChange={togglePhysical}
                name="physical"
              />
            }
            label="Physical"
          />
        </FormGroup>
        <FormGroup row>
          <FormControlLabel
            control={
              <Checkbox
                checked={evMeter}
                onChange={toggleEVMeter}
                name="EVMeter"
              />
            }
            label="EV Meter"
          />
        </FormGroup>
        <Grid container item spacing={2} justifyContent={"flex-end"}>
          <Grid item>
            <MuiButton variant="contained" onClick={save} color="secondary">
              Save
            </MuiButton>
          </Grid>
        </Grid>
        {/* </Grid> */}
      </CardContent>
    </Card>
  );
};

// Component Properties
MeterForm.propTypes = {
  meters: PropTypes.object.isRequired,
  units: PropTypes.object.isRequired,
};

function MeterFormState(state) {
  return {
    meters: state.meters,
    units: state.units,
  };
}
export default connect(MeterFormState, { put, postByUnitUuid })(MeterForm);
